import { Controller } from '@hotwired/stimulus';

function isInvalidRange(earliest: string, latest: string): boolean {
  if (!earliest || !latest) return false;
  const toMinutes = (t: string): number | null => {
    const [hStr, mStr] = t.split(':');
    const h = Number(hStr);
    const m = Number(mStr);
    return Number.isNaN(h) || Number.isNaN(m) ? null : h * 60 + m;
  };

  const eMin = toMinutes(earliest);
  const lMin = toMinutes(latest);
  if (eMin === null || lMin === null) return false;

  return lMin <= eMin;
}

export default class extends Controller {
  static targets = ['hint', 'earliest', 'latest'];

  declare hintTarget: HTMLElement;
  declare earliestTarget: HTMLSelectElement;
  declare latestTarget: HTMLSelectElement;
  declare hasLatestTarget: boolean;
  declare hasEarliestTarget: boolean;

  connect() {
    this.updateHint();
  }

  updateHint(_event?: Event) {
    const earliest = this.hasEarliestTarget ? this.earliestTarget.value : '';
    const latest = this.hasLatestTarget ? this.latestTarget.value : '';

    if (!earliest && !latest) {
      this.hintTarget.textContent = 'Times use 24-hour format (15:00 = 3 pm)';
      this.hintTarget.classList.remove('text-red-600');
      return;
    }

    const fmt12 = (value: string) => {
      if (!value) return '–';
      const [hStr, mStr] = value.split(':');
      const hour = Number(hStr);
      const minute = Number(mStr);
      if (Number.isNaN(hour) || Number.isNaN(minute)) return value;
      const suffix = hour >= 12 ? 'PM' : 'AM';
      const hour12 = ((hour + 11) % 12) + 1;
      return `${hour12}:${minute.toString().padStart(2, '0')} ${suffix}`;
    };

    const earliestDisplay = fmt12(earliest);
    const latestDisplay = fmt12(latest);
    const invalid = isInvalidRange(earliest, latest);

    if (invalid) {
      this.hintTarget.textContent = `⚠️ Selected: ${earliestDisplay} → ${latestDisplay} — ` +
        'Latest time must be after earliest.';
      this.hintTarget.classList.add('text-red');
    } else {
      this.hintTarget.textContent = `Selected: ${earliestDisplay} → ${latestDisplay}`;
      this.hintTarget.classList.remove('text-red');
    }
  }
}
